<template>
  <div class="property-wrap">
    <div class="page-header">
      <div>
        <el-select
          class="select-item"
          v-model="filterData.conversionStatus"
          filterable
          placeholder="请选择转化状态"
        >
          <el-option
            v-for="item of conversionStateOptions"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
        <el-select
          class="select-item multiple-select"
          v-model="filterData.conversionTypes"
          collapse-tags
          multiple
          filterable
          placeholder="请选择转化类型"
        >
          <el-option
            v-for="item of conversionTypeOptions"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
        <el-select
          class="select-item multiple-select"
          v-model="filterData.appIds"
          collapse-tags
          multiple
          filterable
          placeholder="请选择产品"
        >
          <el-option
            v-for="item of productList"
            :key="item.package_name"
            :value="item.package_name"
            :label="item.app_name"
          >
            {{ item.app_name }}（{{ item.package_name }}）
          </el-option>
        </el-select>
        <el-select
          class="select-item multiple-select"
          v-model="filterData.advertiserIds"
          collapse-tags
          multiple
          filterable
          :filter-method="filterCount"
          placeholder="请选择广告账户"
        >
          <el-option
            v-for="item of countList"
            :key="item.advertiserId"
            :value="item.advertiserId"
            :label="item.advertiserName + '(' + item.advertiserId + ')'"
          ></el-option>
        </el-select>
        <el-select
          class="select-item"
          v-model="filterData.displayStatus"
          placeholder="请选择显示状态"
        >
          <el-option
            v-for="item of statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          style="width: 240px; display: inline-block"
          placeholder="请输入转化名称"
          class="select-item"
          v-model="filterData.conversionName"
        ></el-input>
        <el-button class="header-btn" @click="resetFilter" style="margin-left: auto"
          >重置</el-button
        >
        <el-button class="header-btn" @click="searchData" type="primary">查询</el-button>
      </div>
    </div>
    <div class="page-content">
      <div class="btn-list">
        <el-button class="btn-item border-btn" type="primary" @click="showPlBox = true"
          ><svg-icon iconClass="pl" className="pl-icon"></svg-icon>批量操作</el-button
        >
        <el-button class="btn-item border-btn" @click="snycConvert" type="primary" :loading="issnyc"
          ><svg-icon v-show="!issnyc" iconClass="tb" className="icon"></svg-icon
          >{{ issnyc ? "同步中" : "同步" }}</el-button
        >
        <span class="piliang border-bg" v-show="showPlBox">
          <div class="icon-list">
            <el-tooltip content="显示" placement="top">
              <svg-icon
                iconClass="start"
                className="batch-icon"
                @click="batchOperate(1)"
              ></svg-icon>
            </el-tooltip>
            <el-tooltip content="隐藏" placement="top">
              <svg-icon iconClass="stop" className="batch-icon" @click="batchOperate(0)"></svg-icon>
            </el-tooltip>
            <span class="close-icon">
              <svg-icon
                iconClass="close"
                className="close-btn"
                @click="showPlBox = false"
              ></svg-icon>
            </span>
          </div>
        </span>
        <!-- <el-button class="btn-item" icon="el-icon-plus" type="primary" @click="addTransform">新增转化</el-button> -->
      </div>
      <div class="table-wrap">
        <el-table
          :data="tableList"
          style="width: 100%"
          :max-height="tableHeight"
          @selection-change="handleSelectionChange"
        >
          >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="conversionName" label="转化名称"></el-table-column>
          <el-table-column prop="conversionId" label="转化ID"></el-table-column>
          <el-table-column prop="conversionStatus" label="转化状态"></el-table-column>
          <el-table-column prop="conversionType" label="转化类型"></el-table-column>
          <el-table-column prop="appName" label="应用名称"></el-table-column>
          <el-table-column prop="displayStatus" label="显示状态">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.displayStatus"
                @change="changeStatus(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="advertiserName" label="广告账户"></el-table-column>
        </el-table>
        <div class="pro-pagination-wrap">
          <self-pagination
            :total="pageData.total"
            :pageSize="pageData.size"
            :currentPage="pageData.page"
            @getCurrentPage="changePage"
            @handleSizeChange="changePageSize"
          ></self-pagination>
        </div>
      </div>
    </div>
    <edit-modal @refreshList="searchData" ref="editModalRef"></edit-modal>
    <push-modal ref="pushModalRef"></push-modal>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import { getAdCount } from "@/api/property.js";
import {
  getGoogleConversionList,
  updateGoogleConversionStatus,
  getGoogleAppList,
  syncGoogleConversion,
} from "@/api/promotion-google.js";
import EditModal from "./components/editModal.vue";
import PushModal from "./components/push.vue";
import { conversionStateOptions, conversionTypeOptions, statusOptions } from "../config";
export default {
  name: "property",
  components: {
    SvgIcon,
    EditModal,
    PushModal,
  },
  data() {
    return {
      tableHeight: window.innerHeight - 310,
      conversionStateOptions,
      conversionTypeOptions,
      statusOptions,
      productList: [],
      countList: [],
      copyCountList: [],
      accountList: [],
      tableList: [],
      filterData: {
        conversionStatus: "",
        conversionTypes: [],
        appIds: [],
        advertiserIds: [],
        displayStatus: null,
        conversionName: "",
      },
      pageData: {
        page: 1,
        size: 10,
        total: 0,
      },
      showPlBox: false,
      multipleSelection: [],
      issnyc: false, //是否同步中
    };
  },
  mounted() {
    this.initSelect();
    this.getList();
  },
  methods: {
    initSelect() {
      getAdCount({
        platType: 5,
      }).then((res) => {
        if (res.code === "0000") {
          this.countList = res.advertiseInfos;
          this.copyCountList = JSON.parse(JSON.stringify(res.advertiseInfos));
        }
      });
      getGoogleAppList().then((res) => {
        if (res.code === "0000") {
          this.productList = res.data;
        }
      });
    },
    formatParmas() {
      let parmas = {
        pageNum: this.pageData.page,
        pageSize: this.pageData.size,
      };
      for (let [key, value] of Object.entries(this.filterData)) {
        if (value !== -1 && value !== "") {
          parmas[key] = value;
        }
      }
      return parmas;
    },
    searchData() {
      this.pageData.page = 1;
      this.getList();
    },
    getList() {
      let parmas = this.formatParmas();
      getGoogleConversionList(parmas).then((res) => {
        if (res.code === "0000") {
          this.tableList = this.formatTableData(res.data?.list || []);
          this.pageData.total = res.data.total;
        }
      });
    },
    changeStatus(data) {
      updateGoogleConversionStatus({
        ids: [data.id],
        status: data.displayStatus ? 1 : 0,
      }).then((res) => {
        if (res.code === "0000") {
          this.$message.success("修改成功");
          this.changePage(1);
        }
      });
    },
    formatTableData(list) {
      return list.map((item) => {
        item.conversionStatus = this.conversionStateOptions.find(
          (child) => child.value === item.conversionStatus
        )?.label;
        const findObj = this.conversionTypeOptions.find((child) =>
          item.conversionType.includes(child.value)
        );
        item.conversionType = findObj ? findObj.label : "其他";
        item.displayStatus = item.displayStatus === 1 ? true : false;
        return item;
      });
    },
    resetFilter() {
      this.filterData = {
        conversionStatus: "",
        conversionTypes: [],
        appIds: [],
        advertiserIds: [],
        displayStatus: null,
        conversionName: "",
      };
      this.searchData();
    },
    changePage(page) {
      this.pageData.page = page;
      this.getList();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getList();
    },
    addTransform() {
      this.$refs.editModalRef.addTransform();
    },
    checkTransform(data) {
      this.$refs.editModalRef.checkTransform(data);
    },
    push(data) {
      this.$refs.pushModalRef.showconversionModal(data);
    },
    batchOperate(status) {
      if (this.multipleSelection.length <= 0) {
        this.$message({
          type: "warning",
          message: "请至少选择一条数据",
        });
      } else {
        updateGoogleConversionStatus({
          ids: this.multipleSelection.map((item) => item.id),
          status,
        }).then((res) => {
          if (res.code === "0000") {
            this.$message.success("修改成功");
            this.changePage(1);
          }
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    filterCount(value) {
      if (value) {
        this.countList = this.copyCountList.filter((item) => {
          return (
            (item.advertiserId + "").toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            (item.advertiserName + "").toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            (item.company + "").toLowerCase().indexOf(value.toLowerCase()) >= 0
          );
        });
      } else {
        this.countList = this.copyCountList;
      }
    },
    snycConvert() {
      if (this.filterData.advertiserIds.length == 0) {
        this.$message.warning("请选择一个广告账户");
        return;
      }
      if (this.filterData.advertiserIds.length > 1) {
        this.$message.warning("广告账户有且只能选择一个");
        return;
      }
      this.issnyc = true;
      syncGoogleConversion({
        advertiserId: this.filterData.advertiserIds[0],
      }).then((res) => {
        if (res.code === "0000") {
          this.issnyc = false;
          this.$message({
            message: "转化数据同步成功",
            type: "success",
          });
          this.changePage(1);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.property-wrap {
  padding: 16px;
  .page-header {
    // display: flex;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .select-item {
      margin-right: 14px;
      margin-bottom: 12px;
    }
    .header-btn {
      padding: 5px 12px;
    }
  }
  .multiple-select {
    width: 250px;
    /deep/ .el-tag.el-tag--info:first-child {
      max-width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .page-content {
    margin-top: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .btn-list {
      display: flex;
      .btn-item {
        padding: 5px 18px;
        .pl-icon {
          margin-right: 8px;
        }
        .icon {
          margin-right: 6px;
        }
        &.border-btn {
          color: rgba(24, 144, 255, 1);
          border-radius: 2px;
          border: 1px solid rgba(24, 144, 255, 1);
          background: rgba(255, 255, 255, 1);
        }
        .rotate {
          transition: rotating 2s linear infinite !important;
        }
      }
    }
    .table-wrap {
      margin-top: 16px;
      min-height: 300px;
      width: calc(100vw - 260px);
      .pro-pagination-wrap {
        height: 58px;
      }
    }
  }
}
.piliang {
  height: 30px;
  line-height: 32px;
  padding-left: 12px;
  margin-left: 12px;
  display: flex;
  justify-content: space-between;
  .batch-span {
    font-size: 13px;
    color: rgba(0, 0, 0, 1);
    a {
      color: rgba(24, 144, 255, 1);
      margin: 0 5px;
    }
  }
  .icon-list {
    // margin-left: 58px;
    color: rgba(24, 144, 255, 1);
  }
  .batch-icon {
    margin-right: 26px;
    cursor: pointer;
  }
  .close-btn {
    color: rgba(0, 0, 0, 0.6);
    font-size: 12px;
    margin: 0 16px 0 0px;
    cursor: pointer;
  }
}
</style>
